module.exports = __webpack_public_path__ + "static/media/seed7.9af49198.svg";